import { ReactComponent as IconDocument } from "@/assets/svgs/document-list.svg";
import { ReactComponent as IconAddressBook } from "@/assets/svgs/icon-book-open.svg";
import Tabs, { Tab } from "@/components/Tabs";
import Toast from "@/components/Toast/index";
import toastType from "@/constants/toast-type/index";
import usePage from "@/hooks/use-page";
import useRecordDetail from "@/hooks/use-record-detail/index";
import useToast from '@/hooks/use-toast';
import AttachmentsPage from "@/pages/record-transfer/attachments/index";
import { clearTTDataAndFile } from "@/redux/actions/trade-trust";
import "@/translations/i18n";
import { uniqueId } from "lodash";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import AddressBookPage from "./address-book/index";
import ETRIssuanceComponent from "@/pages/record-transfer/etr-issuance/index";
import Breadcrumbs from "@/componentsDS/Breadcrumbs/index";

const RecordTransferPage = () => {
	/*=================================================
		General
	/================================================*/

	const dispatch = useDispatch()

	const [path, setPath] = useState("e_tranferrable_record");

	const pageTitle = "E-Transferable Record";
	const { breadcrumbsItems } = usePage({
		title: pageTitle,
		breadcrumbs: [
			{
				label: '',
				link: '/'
			 },
			{
				label: 'E-Transferable Record',
				link: ''
			 }
		]
	});

	/*=================================================
		API
	/================================================*/

	const { toastList, addToastMessage } = useToast()
	const { recordDetailErrorMsg } = useRecordDetail();

	useEffect(() => {
		if (recordDetailErrorMsg) {
			addToastMessage(recordDetailErrorMsg, toastType.error)
			// Remove tt record from redux if API returns error
			dispatch(clearTTDataAndFile())
		}
	}, [recordDetailErrorMsg])

	/*=================================================
		Tabs
	/================================================*/

	const tabsItems = [
		{
			label: "ETR List",
			active: path === "e_tranferrable_record",
			path: "e_tranferrable_record",
			prefix: <IconDocument />,
			disabled: false,
			id: "record_transfer_e_transferable_record"
		},
		{
			label: "Addressbook",
			active: path === "address-book",
			path: "address-book",
			prefix: <IconAddressBook />,
			disabled: false,
			id: "record_transfer_addressbook"
		},
	]

	/*=================================================
		Dropzone
	/================================================*/

	return (
		<>
			<Breadcrumbs breadcrumbItems={breadcrumbsItems}/>
			<div className="title-header">
				<div className="title-header__left">
					<div
						className="title-header__title"
						data-testid={"title-header"}
					>
						{pageTitle}
					</div>
				</div>
			</div>

			<Tabs>
				{tabsItems.map((item) => {
					const id = uniqueId()
					return !item.disabled && (
						<Tab
							key={id}
							label={item.label}
							active={path === item.path}
							prefix={item.prefix}
							onClick={() => {
								setPath(item.path)
							}}
							counter={item.counter}
							id={item.id}
						/>
					)
				})}
			</Tabs>

			<div className="title-header__hr">
				<hr />
			</div>
			<div className="etr__overview__margin_top">
				{path === "e_tranferrable_record" && <div>
					<ETRIssuanceComponent />
				</div>}
				{path === "attachments" && (
					<AttachmentsPage
						isClick={true}
					/>
				)}
				{path === "address-book" && (
					<AddressBookPage />
				)}
			</div>

			<Toast toastList={toastList} />
		</>
	);
};

export default RecordTransferPage;
